// TOP LEVEL IMPORTS
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import windowSize from 'react-window-size';
import SearchBox from 'components/common/SearchBox';
import Fuse from 'fuse.js';
// import SectionHeader from 'components/text/SectionHeader';
// ANTD
import Table from 'antd/lib/table';
import Tag from 'antd/lib/tag';
import 'antd/lib/table/style/css';
// APOLLO
import { graphql, compose } from 'react-apollo';
import { propType } from 'graphql-anywhere';
import getClientsQuery from 'ApolloClient/Queries/getClients';
import clientFragment from 'ApolloClient/Fragments/clientFragment';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import DownloadClientsButton from './DownloadClientsButton';

const TagWrapper = styled.div`
  .ant-tag {
    border: 0px !important;
  }
`;

class ClientsTable extends React.PureComponent {
  state = {
    clients: [],
    searchText: '',
    filteredInfo: null,
    sortedInfo: {
      order: 'ascend',
      columnKey: 'lastName',
    },
  };

  componentDidMount() {
    if (!this.props.data.loading && this.props.data.clients) {
      this.setOptions(this.props.data.clients);
    }
  }

  componentWillReceiveProps(newProps) {
    const { clients } = this.props.data;

    if (this.props.data.loading && !newProps.data.loading) {
      return this.setOptions(newProps.data.clients);
    }

    if (clients && newProps.data.clients && clients.length !== newProps.data.clients.length) {
      return this.setOptions(newProps.data.clients);
    }

    return newProps;
  }

  filterOptions = searchText => {
    let searchOptions;
    this.setState({ searchText });
    searchOptions = this.state.clients.map(item => ({
      ...item,
    }));
    if (searchText.length === 0) {
      this.setState({ results: this.state.clients });
    }
    let fuse = new Fuse(searchOptions, {
      shouldSort: true,
      threshold: 0.5,
      location: 0,
      distance: 100,
      maxPatternLength: 12,
      minMatchCharLength: 1,
      keys: ['firstName', 'lastName', 'email', 'clientTags.title'],
    });

    let searchResults = fuse.search(searchText);
    if (searchResults && searchResults.length > 0) {
      return this.setState({ results: searchResults });
    }
  };

  setOptions = clients => {
    this.setState({ clients, results: clients });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };

  render() {
    const { history, data, windowWidth } = this.props;
    const { error } = data;
    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    if (error) {
      console.log(error);
      return <span>Something went wrong :(</span>;
    }

    const MOBILE_COLUMNS = [
      {
        title: 'STATUS',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'FULL NAME',
        render: (text, record) => `${record.firstName || ''} ${record.lastName || ''}`,
      },
      {
        title: 'PHONE',
        dataIndex: 'phone',
        key: 'phone',
        render: (text, record) => <a href={`tel:+${record.phone}`}>{record.phone}</a>,
      },
    ];

    let FULL_SCREEN_COLUMNS = [
      {
        title: 'STATUS',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => <TagWrapper><Tag color={record.status === 'Lead' ? 'blue' : null}>{record.status}</Tag></TagWrapper>,
        sorter: (a, b) => a.status.localeCompare(b.status),
        // sorter: (a, b) => a.status.length - b.status.length,
        sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
      },
      {
        title: 'FIRST',
        dataIndex: 'firstName',
        key: 'firstName',
        sorter: (a, b) => a.firstName.localeCompare(b.firstName),
        sortOrder: sortedInfo.columnKey === 'firstName' && sortedInfo.order,
      },
      {
        title: 'LAST',
        dataIndex: 'lastName',
        key: 'lastName',
        sorter: (a, b) => a.lastName.localeCompare(b.lastName),
        sortOrder: sortedInfo.columnKey === 'lastName' && sortedInfo.order,
      },
      {
        title: 'EMAIL',
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => a.email.localeCompare(b.email),
        // sorter: (a, b) => a.email.toLowerCase().length - b.email.toLowerCase().length,
        sortOrder: sortedInfo.columnKey === 'email' && sortedInfo.order,
      },
      {
        title: 'TAGS',
        render: (text, record) => (
          <React.Fragment>
            {record.clientTags
              && record.clientTags.length > 0
              && record.clientTags.map(item => (
                <TagWrapper><Tag color="cyan" key={item._id}>
                  {item.title}
                </Tag></TagWrapper>
              ))}
          </React.Fragment>
        ),
      },
      {
        title: 'PHONE',
        dataIndex: 'phone',
        key: 'phone',
        render: (text, record) => <a href={`tel:+${record.phone}`}>{record.phone}</a>,
      },
      {
        title: 'CREATED',
        key: 'createdAt',
        render: (text, record) => <span>{GeneralHelpers.formatShortDate(record.createdAt)}</span>,
        // TODO: add back sorter
        sorter: (a, b) => moment(a.createdAt || 0).unix() - moment(b.createdAt || 0).unix(),
        sortOrder: sortedInfo.columnKey === 'createdAt' && sortedInfo.order,
      },
    ];

    return (
      <div style={{ display: 'relative' }}>
        <SearchBox
          style={{ width: windowWidth < 789 ? '100%' : '50%' }}
          searchText={this.state.searchText}
          onSearchTextChange={this.filterOptions}
        />

        <Table
          rowKey={record => record._id}
          onRow={record => ({
            onClick: () => history.push(`/app/clients/${record._id}`),
          })}
          onChange={this.handleChange}
          loading={this.props.data.loading}
          columns={windowWidth < 789 ? MOBILE_COLUMNS : FULL_SCREEN_COLUMNS}
          dataSource={this.state.results}
          defaultPageSize={20}
          pagination={{
            defaultPageSize: 20,
          }}
        />
        {/* <SectionHeader>DOWNLOAD CSV</SectionHeader> */}
        <DownloadClientsButton dataSource={this.state.results} />
      </div>
    );
  }
}

ClientsTable.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    clients: PropTypes.arrayOf(propType(clientFragment)),
  }).isRequired,
  windowWidth: PropTypes.number.isRequired,
};

const enhance = compose(
  withRouter, // provides access to history.push.
  graphql(getClientsQuery), // provides access to clients table data.
  windowSize, // provides access to windowWidth and windowHeight.
);

export default enhance(ClientsTable);



// WEBPACK FOOTER //
// ./src/routes/app-clients/ClientsTable/index.js